<template>
  <div v-if="isLoading" class="loading d-flex flex-column justify-center align-center">
    <h2 class="white--text mb-6" v-if="loadingMessage.length > 0">{{ loadingMessage }}</h2>
    <v-progress-circular
        :size="100"
        color="primary"
        indeterminate
    ></v-progress-circular>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class LoadingComponent extends Vue {

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: '' })
  public loadingMessage!: string;
}
</script>

<style lang="scss" scoped>

.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
